module.exports = __webpack_public_path__ + "img/logo5.2cd35ec1.png";